import { RadicationCompleteComponent } from './pages/radication-complete/radication-complete.component';
import { SolicitationDataComponent } from './pages/solicitation-data/solicitation-data.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SolicitationDetailComponent } from './pages/solicitation-detail/solicitation-detail.component';
import { SolicitationStartComponent } from './pages/solicitation-start/solicitation-start.component';
import { SolicitationSearchComponent } from './pages/solicitation-search/solicitation-search.component';
import { RequirementsStartComponent } from './pages/requirements-start/requirements-start.component';
import { FiducialBankHomeComponent } from './pages/fiducial-bank-home/fiducial-bank-home.component';
import { BankStartComponent } from './pages/bank-start/bank-start.component';
import { RecaptchaErrorComponent } from './pages/recaptcha-error/recaptcha-error.component';

const routes: Routes = [
  { path: 'default', component: SolicitationStartComponent },
  { path: '', component: SolicitationStartComponent },
  { path: 'solicitation-start', component: SolicitationStartComponent }, //Paso 1
  { path: 'solicitation-data', component: SolicitationDataComponent }, // Paso 2
  { path: 'solicitation-detail', component: SolicitationDetailComponent }, // Paso 3
  { path: 'radication-complete', component: RadicationCompleteComponent },  // Paso 4
  { path: 'solicitation-search', component: SolicitationSearchComponent }, //Consulta de solicitudes
  { path: 'requirements-start', component: RequirementsStartComponent }, //Paso 1 Radicar Requerimientos  
  { path: 'fiducial-bank-home', component: FiducialBankHomeComponent },
  { path: 'bank-start', component: BankStartComponent },
  { path: 'recaptcha-error', component: RecaptchaErrorComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
